const GENERATEFILE = "/drive/upload";
const DELETEFILE = "/drive/delete";

export const generateFile = { GENERATEFILE, DELETEFILE };
